/**
 * Sticker Store System (The Meta-Game loop)
 * Kids spend Stars to unlock collectible stickers
 */

const StickerStore = {
    // Inventory definition - Detective themed items
    catalog: [
        // Accesorios de vestir
        { id: 'acc_hat', name: 'Sombrero Detective', price: 5, icon: '🎩', category: 'acc', wearable: true, gender: 'm', plural: false },
        { id: 'acc_glasses', name: 'Gafas de Detective', price: 3, icon: '👓', category: 'acc', wearable: true, gender: 'f', plural: true },
        { id: 'acc_cape', name: 'Capa de Superdetective', price: 15, icon: '🦸‍♂️', category: 'acc', wearable: true, gender: 'f', plural: false },

        // Ayudantes animales
        { id: 'pet_dog', name: 'Ayudante Canino', price: 8, icon: '🐕‍🦺', category: 'pet', wearable: false, gender: 'm', plural: false },

        // Vehículos y transporte
        { id: 'vehicle_bike', name: 'Bicicleta Detectivesca', price: 10, icon: '🚲', category: 'vehicle', wearable: false, gender: 'f', plural: false },

        // Herramientas de investigación
        { id: 'tool_magnifier', name: 'Lupa Mágica', price: 5, icon: '🔍', category: 'tool', wearable: false, gender: 'f', plural: false },
        { id: 'tool_notebook', name: 'Bloc de Notas', price: 4, icon: '📓', category: 'tool', wearable: false, gender: 'm', plural: false },
        { id: 'tool_calculator', name: 'Calculadora', price: 6, icon: '🧮', category: 'tool', wearable: false, gender: 'f', plural: false },
        { id: 'tool_fingerprint', name: 'Kit de Huellas', price: 9, icon: '🔬', category: 'tool', wearable: false, gender: 'm', plural: false },
        { id: 'tool_camera', name: 'Cámara de Fotos', price: 7, icon: '📷', category: 'tool', wearable: false, gender: 'f', plural: false },
        { id: 'tool_robot', name: 'Robot Ayudante', price: 20, icon: '🤖', category: 'tool', wearable: false, gender: 'm', plural: false },
        { id: 'tool_umbrella', name: 'Paraguas Protector', price: 8, icon: '☂️', category: 'tool', wearable: false, gender: 'm', plural: false }
    ],

    loadInventory() {
        // Placeholder for inventory loading if needed, or alias to renderStore
        if (window.GamificationService) {
            // Ensure inventory exists in gamification service
            const progress = window.GamificationService.getProgress();
            if (!progress.inventory) progress.inventory = [];
        }
    },

    onCloseCallback: null,

    /**
     * Open the Store Screen
     */
    openStore(onClose) {
        if (window.stopAudio) window.stopAudio();
        this.onCloseCallback = onClose;

        // Ensure store screen exists
        let storeScreen = document.getElementById('storeScreen');
        if (!storeScreen) {
            storeScreen = document.createElement('div');
            storeScreen.id = 'storeScreen';
            storeScreen.className = 'screen';
            document.body.appendChild(storeScreen);
        }

        // Render structure if empty
        if (!storeScreen.innerHTML) {
            storeScreen.innerHTML = `
                <div class="container mobile-scroll-container" style="padding: 0.5rem;">
                    <header class="header" style="padding: 0.5rem 0; margin-bottom: 0.5rem;">
                        <button id="closeStoreBtn" class="btn-back-global visible" style="position: absolute; left: 20px; padding: 0.3rem 0.6rem; font-size: 0.8rem;">
                            ← VOLVER
                        </button>
                        <h1 class="main-title high-contrast store-title" style="font-size: 1.5rem; margin: 0;">🏪 Tienda de Detectives</h1>
                        <div class="title-underline" style="margin-top: 0.3rem;"></div>
                    </header>
                    
                    <div class="store-stats" style="margin-bottom: 0.5rem;">
                        <div class="user-stars-display" style="font-size: 1rem; padding: 0.3rem 0.6rem;">
                            <span>⭐</span>
                            <span id="storeUserStars">0</span>
                        </div>
                    </div>

                    <main class="store-main" style="padding: 0;">
                        <div id="storeGrid" class="store-grid">
                            <!-- Items will be injected here -->
                        </div>
                    </main>
                </div>
            `;

            // Bind events
            document.getElementById('closeStoreBtn').onclick = () => this.closeStore();
        }

        // Show screen
        storeScreen.classList.remove('hidden');
        storeScreen.classList.add('active');
        storeScreen.style.zIndex = '10000'; // Muy alto para estar encima de todo
        storeScreen.style.background = '#F0F9FF'; // Light blue background
        storeScreen.style.display = 'block'; // Forzar display
        storeScreen.style.position = 'fixed'; // Asegurar posicionamiento
        storeScreen.style.top = '0';
        storeScreen.style.left = '0';
        storeScreen.style.width = '100%';
        storeScreen.style.height = '100%';
        storeScreen.style.overflow = 'auto'; // Permitir scroll si es necesario

        // Escalar contenido Removed as per user request for better centering
        // const container = storeScreen.querySelector('.container');
        // if (container) {
        //     container.style.transform = 'scale(0.75)';
        //     container.style.transformOrigin = 'top center';
        //     container.style.width = '133%'; // Compensar el escalado (100/0.75)
        //     container.style.marginLeft = '-16.5%'; // Centrar horizontalmente
        // }

        // Update UI
        this.renderStore();
    },

    /**
     * Close the Store
     */
    closeStore() {
        if (window.stopAudio) window.stopAudio();
        const storeScreen = document.getElementById('storeScreen');
        if (storeScreen) {
            storeScreen.classList.add('hidden');
            storeScreen.classList.remove('active');
        }

        if (this.onCloseCallback) {
            this.onCloseCallback();
            this.onCloseCallback = null;
        }
    },

    /**
     * Render store items and status
     */
    renderStore() {
        if (!window.GamificationService) return;

        const progress = window.GamificationService.getProgress();
        const stars = progress.stars || 0;
        const inventory = progress.inventory || [];

        // Update Stars Display
        const starsEl = document.getElementById('storeUserStars');
        if (starsEl) starsEl.textContent = stars;

        const grid = document.getElementById('storeGrid');
        if (!grid) return;

        grid.innerHTML = '';

        this.catalog.forEach(item => {
            const isOwned = inventory.includes(item.id);
            const canAfford = stars >= item.price;

            const card = document.createElement('div');
            card.className = `store-item-card ${isOwned ? 'owned' : ''}`;
            card.innerHTML = `
                <div class="item-icon">${item.icon}</div>
                <h3 class="item-name">${item.name}</h3>
                ${!isOwned ? `<div class="item-price">⭐ ${item.price}</div>` : '<div class="item-owned-badge">✓ EN TU MOCHILA</div>'}
                <button class="btn ${isOwned ? 'btn-secondary' : (canAfford ? 'btn-primary' : 'btn-disabled')}" 
                    ${!isOwned && !canAfford ? 'disabled' : ''}>
                    ${isOwned ? 'EQUIPAR' : 'COMPRAR'}
                </button>
            `;

            const btn = card.querySelector('button');
            btn.onclick = () => {
                if (isOwned) {
                    this.equipItem(item.id);
                } else if (canAfford) {
                    this.buyItem(item);
                }
            };

            grid.appendChild(card);
        });
    },

    /**
     * Buy an item
     */
    buyItem(item) {
        if (!window.GamificationService) return;

        const progress = window.GamificationService.getProgress();
        if (progress.stars >= item.price) {
            // Deduct stars
            progress.stars -= item.price;

            // Add to inventory
            if (!progress.inventory) progress.inventory = [];
            progress.inventory.push(item.id);

            // Save
            window.GamificationService.saveProgress();

            // Play sound
            if (window.SoundService) window.SoundService.playSuccess();
            if (window.speak) window.speak(`¡Has comprado ${item.name}!`, 'es-ES');

            // Re-render
            this.renderStore();
        }
    },

    /**
     * Equip an item on the detective
     */
    equipItem(itemId) {
        const item = this.catalog.find(i => i.id === itemId);
        if (!item) return;

        // Gramática Helper
        const getArticle = (itm) => {
            if (itm.gender === 'f') return itm.plural ? 'las' : 'la';
            return itm.plural ? 'los' : 'el';
        };
        const getParticiple = (itm) => { // añadido, añadida...
            if (itm.gender === 'f') return itm.plural ? 'añadidas' : 'añadida';
            return itm.plural ? 'añadidos' : 'añadido';
        };

        const article = getArticle(item);
        const articleCap = article.charAt(0).toUpperCase() + article.slice(1);
        const participle = getParticiple(item);

        if (item.wearable) {
            // WEARABLE ITEMS
            if (window.DetectiveMentor) {
                window.DetectiveMentor.setAccessory(item);
            }

            // Feedback con concordancia
            const msg = `¡Genial! Me he puesto ${article} ${item.name}`;
            if (window.DetectiveMentor) {
                window.DetectiveMentor.speak(msg, 'success');
            } else if (window.speak) {
                window.speak(msg, 'es-ES');
            }
        } else {
            // NON-WEARABLE ITEMS
            if (window.DetectiveMentor) {
                window.DetectiveMentor.addBackpackItem(item);
            }

            // Feedback con concordancia
            const msg = `¡${articleCap} ${item.name} ha sido ${participle} a tu mochila!`;
            if (window.DetectiveMentor) {
                window.DetectiveMentor.speak(msg, 'success');
            } else if (window.speak) {
                window.speak(msg, 'es-ES');
            }
        }
    }
};

window.StickerStore = StickerStore;
